/* Template Components */
export const routes = [
    /* Otherwise Redirect to Home */
    { path: '*', redirect: '/' },

    /* Login Routing */
    {
        path: '/login',
        name: 'Login',
        component: () =>
            import ('@/views/AuthLogin.vue')
    },
    {
        path: '/register',
        name: 'Register',
        component: () =>
            import ('@/views/AuthRegister.vue')
    },

    /* Statics, Secondary Routing */
    {
        path: '/',
        name: 'Home',
        component: () =>
            import ('@/views/Home.vue')
    },
    {
        path: '/notallowed',
        name: 'Notallowed',
        component: () =>
            import ('@/views/Notallowed.vue')
    },


    /* Principal App Routing */
    {
        path: '/bookings',
        name: 'Bookings',
        component: () =>
            import ('@/views/Bookings.vue')
    },
    {
        path: '/availability',
        name: 'Availability',
        component: () =>
            import ('@/views/Availability.vue')
    },
    {
        path: '/hotels',
        name: 'Hotels',
        component: () =>
            import ('@/views/Hotels')
    },
    {
        path: '/rateplans',
        name: 'Rate Plans',
        component: () =>
            import ('@/views/RatePlans.vue')
    },
    {
        path: '/rates',
        name: 'Rates',
        component: () =>
            import ('@/views/Rates.vue')
    },
    {
        path: '/logs',
        name: 'Logs',
        component: () =>
            import ('@/views/Logs.vue')
    },
    {
        path: '/logstock',
        name: 'Logstock',
        component: () =>
            import ('@/views/Logstock.vue')
    },
    {
        path: '/roomtypes',
        name: 'Room Types',
        component: () =>
            import ('@/views/RoomTypes.vue')
    },
    {
        path: '/inventory',
        name: 'Inventory',
        component: () =>
            import ('@/views/Inventory.vue')
    },
    {
        path: '/childspolicies',
        name: 'Child Policies',
        component: () =>
            import ('@/views/ChildsPolicies.vue')
    },
    {
        path: '/integration',
        name: 'Integration',
        component: () =>
          import ('@/views/Integration.vue')
    },
    {
        path: '/emails',
        name: 'Emails',
        component: () =>
          import ('@/views/Emails.vue')
    },
    {
        path: '/users',
        name: 'Users',
        component: () =>
          import ('@/views/Users.vue')
    },
    {
        path: '/clients',
        name: 'Clients',
        component: () =>
          import ('@/views/Clients.vue')
    },
    {
        path: '/hotels/status',
        name: 'Hotels Status',
        component: () =>
            import ('@/views/HotelsStatus')
    }
];



// WEBPACK FOOTER //
// ./src/routes/router.js